import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ea81ef3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "members" }
const _hoisted_2 = { class: "member-info" }
const _hoisted_3 = { class: "member-name" }
const _hoisted_4 = { class: "member-role" }

import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import { Member } from '@/Member/member.entity';

import MemberAvatar from './MemberAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LitigationMembersListModal',
  props: {
    litigationName: {
        type: String,
        required: false,
        default: '',
    },
    members: {
        type: Array as PropType<Member[]>,
        required: true,
    },
},
  emits: ['close'],
  setup(__props) {

const props = __props;





const { members, litigationName } = toRefs(props);

const { t } = useI18n();

const headerTitle = computed(() => [litigationName.value, t('listMembers.members')].filter(Boolean).join(' '));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(CustomModal, {
      "min-width": "600px",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      "modal-header": _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(headerTitle.value), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(members), (member) => {
            return (_openBlock(), _createElementBlock("div", {
              key: member.memberId ?? member.email,
              class: "member-container"
            }, [
              _createVNode(MemberAvatar, {
                member: member,
                "disable-click-events": "",
                "disable-role-expansion": ""
              }, null, 8, ["member"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('listMembers.roles.' + member.role)), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})